import styled from 'styled-components'
import { Layout } from 'antd'

export default styled(Layout)`
  height: 100vh;
  min-width: 1200px;
  background-color: ${({ theme }) => theme.colors.light};
`
